import { FC } from 'react';

import { FilterState } from '@/context/FilterProvider';
import { FilterMaterializationType } from '@/typings/dbt';
import { toTitleCase } from '@/util/string';
import { BaseFilterToggle, FilterToggleProps } from './BaseFilterToggle';

interface ModelMaterializationToggleProps extends FilterToggleProps {
  materializationType: FilterMaterializationType;
  onToggle: FilterState['updateFilters'];
  count?: number;
}

export const ModelMaterializationToggle: FC<ModelMaterializationToggleProps> = (
  props,
) => {
  const { materializationType, isChecked, count } = props;

  const onToggle = () =>
    props.onToggle({ materialization: [materializationType] }, !isChecked);

  return (
    <BaseFilterToggle {...props} compact onToggle={onToggle} count={count}>
      <span className="flex-1">{toTitleCase(materializationType)}</span>
    </BaseFilterToggle>
  );
};
